import React from 'react';
import PropTypes from 'prop-types';
import Modal, {modalSizes} from 'components/layout/modal';
import {injectIntl, intlShape} from 'react-intl';

class TruBlueModal extends React.Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    onClose: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
  };

  render() {
    let {children, onClose, intl} = this.props;
    const {locale} = intl;

    return <Modal size={modalSizes.large}
                  onClose={onClose}
                  className='trublue-modal'
                  headerImage={locale === 'fr-CA' ? '/Content/img/trublue/trublue-promise-logo-fr.png' : '/Content/img/trublue/trublue-promise-logo.png'}>
      {children}
    </Modal>;
  }
}

export default injectIntl(TruBlueModal);
